<template>
    <b-form-group
            :id="name"
            :label="label"
            :label-for="name">
        <editor
                api-key="1tm8qm9at2m3557gxm2ahn763maxteqbzsoba997shbhlgby"
                :init="{
         height: 500,
         menubar: false,
         plugins: [
           'advlist autolink lists link image charmap print preview anchor',
           'searchreplace visualblocks code fullscreen',
           'insertdatetime media table paste code help wordcount'
         ],
         toolbar:
           'undo redo | formatselect | fontsizeselect | bold italic backcolor | \
           alignleft aligncenter alignright alignjustify | \
           bullist numlist outdent indent | removeformat | link | code | image'
       }"

                v-model="editorData"
                @input="updateField"
        ></editor>

    </b-form-group>
</template>

<script>
    import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
    import Editor from '@tinymce/tinymce-vue'

    export default {
        name: 'TextInput',
        props: ['placeholder', 'label', 'name', 'value'],
        components: {
            'editor': Editor
        },
        data() {
            return {
                editor: ClassicEditor,
                editorData: this.value ? this.value : '',
                editorConfig: {}
            };
        },
        methods: {
            updateField: function () {
                let formattedValue = this.editorData;
                this.$emit('input', String(formattedValue));
            }
        },
        watch: {
            value: function (newValue) {
                this.editorData = newValue;
            }
        },
    }

</script>